/**
 * Simple cache utility for storing and retrieving values in localStorage
 */
export class CacheService {
  private static readonly CACHE_KEY_PREFIX = 'campo_';

  /**
   * Store a value in cache
   * @param key - The cache key
   * @param value - The value to store
   */
  static set(key: string, value: string): void {
    try {
      localStorage.setItem(`${this.CACHE_KEY_PREFIX}${key}`, value);
    } catch (error) {
      console.error('Error storing value in cache:', error);
    }
  }

  /**
   * Retrieve a value from cache
   * @param key - The cache key
   * @returns The cached value or null if not found
   */
  static get(key: string): string | null {
    try {
      return localStorage.getItem(`${this.CACHE_KEY_PREFIX}${key}`);
    } catch (error) {
      console.error('Error retrieving value from cache:', error);
      return null;
    }
  }

  /**
   * Remove a value from cache
   * @param key - The cache key
   */
  static remove(key: string): void {
    try {
      localStorage.removeItem(`${this.CACHE_KEY_PREFIX}${key}`);
    } catch (error) {
      console.error('Error removing value from cache:', error);
    }
  }

  /**
   * Clear all cached values
   */
  static clear(): void {
    try {
      const keys = Object.keys(localStorage);
      keys.forEach(key => {
        if (key.startsWith(this.CACHE_KEY_PREFIX)) {
          localStorage.removeItem(key);
        }
      });
    } catch (error) {
      console.error('Error clearing cache:', error);
    }
  }
}